import { services } from "@/utils/config/services";
import { customFetch } from "../customFetch";

export const notifications = {
  getNotifications: (page: number, pageSize: number, companyId?: string) => {
    let url = `${services.users}/me/notifications?PageNumber=${page}&PageSize=${pageSize}`;
    if (companyId) {
      url += `&CompanyId=${companyId}`;
    }
    return customFetch(url);
  },
  getUnreadCount: (companyId?: string) => {
    let url = `${services.users}/me/notifications/unread-count`;
    if (companyId) {
      url += `?CompanyId=${companyId}`;
    }
    return customFetch(url);
  },
  markAsRead: (id: string) =>
    customFetch(`${services.users}/me/notifications/${id}/read`, {
      method: "POST",
    }),
  markAllAsRead: (companyId?: string) => {
    let url = `${services.users}/me/notifications/read-all`;
    if (companyId) {
      url += `?CompanyId=${companyId}`;
    }
    return customFetch(url, { method: "POST" });
  },
};
